import React from "react";
import { Link } from "react-router-dom";
import { FAQS } from "@/data/faqs";
import Reveal from "@/components/Reveal";
import CountUp from "@/components/CountUp";

export default function FaqPage() {
  return (
    <section className="faq page-pad">
      <div className="wrap">
        <Reveal className="section__head">
          <p className="eyebrow">FAQ</p>
          <h1 className="page-title">What teams usually ask.</h1>
          <p>Direct answers for humans and answer engines.</p>
        </Reveal>

        <Reveal className="page-metrics" delay={80}>
          <div className="page-metric">
            <strong>
              <CountUp to={FAQS.length} />
            </strong>
            <span>Questions answered</span>
          </div>
          <div className="page-metric">
            <strong>
              <CountUp to={3} />
            </strong>
            <span>Practice lanes</span>
          </div>
          <div className="page-metric">
            <strong>
              <CountUp to={2} />
            </strong>
            <span>Live Shopify apps</span>
          </div>
        </Reveal>

        <div className="faq-list">
          {FAQS.map((item, i) => (
            <Reveal as="article" className="faq-item" key={item.q} delay={100 + i * 70}>
              <h2 style={{ fontSize: "1.15rem", fontFamily: "var(--font-display)", letterSpacing: "-0.03em" }}>
                {item.q}
              </h2>
              <p style={{ marginTop: "0.55rem", color: "var(--muted)" }}>{item.a}</p>
            </Reveal>
          ))}
        </div>

        <Reveal className="page-cta" delay={200}>
          <Link className="btn" to="/contact">
            Start a project
          </Link>
          <Link className="btn btn--ghost" to="/services">
            View services
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
